import React from 'react';
import { Package } from 'lucide-react';

// stockQty: mevcut stok, minStockQty: eşik, unit: birim
export function StockBadge({ stockQty, minStockQty = 0, unit = 'adet' }) {
  const qty = Number(stockQty ?? 0);
  const min = Number(minStockQty ?? 0);

  let color, label;
  if (qty === 0) {
    color = 'bg-red-100 text-red-700';
    label = 'Tükendi';
  } else if (min > 0 && qty <= min) {
    color = 'bg-amber-100 text-amber-700';
    label = `${qty} ${unit}`;
  } else {
    color = 'bg-green-100 text-green-700';
    label = `${qty} ${unit}`;
  }

  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${color}`}>
      <Package className="h-3 w-3" />
      {label}
    </span>
  );
}
